import { useEffect } from 'react';
import { config } from '@uhg-abyss/web/tools/config';

const Reactor = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR guard

    const initializeRakantoGlobal = () => {
      window['RakantoObject'] = 'Rakanto';
      window['Rakanto'] =
        window['Rakanto'] ||
        function () {
          (window['Rakanto'].q = window['Rakanto'].q || []).push(
            [Date.now()].concat(Array.prototype.slice.call(arguments))
          );
        };
      window['Rakanto'].l = Date.now();
      window['Rakanto'].demarcs = undefined;
    };

    const createReactorScript = (scriptUrl: string) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.id = 'rakanto';
      scriptElement.async = true;

      const darids = config('OPTUM_REACTOR_ANALYTICS_DARIDS');
      if (darids) {
        scriptElement.setAttribute('data-px-darids', darids);
      }

      return scriptElement;
    };

    const insertScript = (scriptElement: HTMLScriptElement) => {
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(scriptElement, firstScript);
      } else {
        // Fallback: append to document head or body
        const target = document.head || document.body;
        if (target) {
          target.appendChild(scriptElement);
        }
      }
    };

    const loadScript = () => {
      const scriptUrl = config('OPTUM_REACTOR_ANALYTICS_CX_SCRIPT');

      if (!scriptUrl) {
        return;
      }

      initializeRakantoGlobal();

      const scriptElement = createReactorScript(scriptUrl);
      insertScript(scriptElement);
    };

    loadScript();
  }, []);

  return null;
};

export default Reactor;
